// services/notifications-signalr.ts
import * as SignalR from '@microsoft/signalr';
import { store } from './../index';
import { setUnreadCount } from '../slices/notification-slice';
import { notificationsApi } from '../services/api/notifications-api';
import { baseUrl } from '../services/api/base-api';

let connection: SignalR.HubConnection | null = null;

export const startNotificationHub = async (userId: string) => {
  if (connection) return; // already connected

  connection = new SignalR.HubConnectionBuilder()
    .withUrl(`${baseUrl}notificationsHub?userId=${userId}`)
    .withAutomaticReconnect()
    .build();

  connection.on('ReceiveUnreadCount', (count) => {
    store.dispatch(setUnreadCount(count));
  });

  try {
    await connection.start();
    console.log('SignalR connected');

    await store.dispatch(
      notificationsApi.endpoints.InitialNotifications.initiate(userId)
    ).unwrap();

    console.log('Initial notifications fetched');
  } catch (err) {
    console.error('SignalR connection error:', err);
  }
};

export const stopNotificationHub = async () => {
  if (connection) {
    await connection.stop();
    connection = null;
  }
};
